import { cloneElement, type ReactElement, type ReactNode } from "react";

export interface EmptyStateProps {
  icon: ReactElement<{ size?: number }>;
  title: string;
  body: string;

  cta?: ReactNode;
}

export function EmptyState({ icon, title, body, cta }: Readonly<EmptyStateProps>) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="mb-4 grid size-12 place-items-center rounded-2xl bg-brand-primary-subtle text-brand-primary-on-subtle">
        {cloneElement(icon, { size: 22 })}
      </div>
      <h3 className="text-base font-semibold text-content-primary">{title}</h3>
      <p className="mt-1 max-w-sm [font:var(--type-body-xs)] text-content-secondary">{body}</p>
      {cta && <div className="mt-4">{cta}</div>}
    </div>
  );
}
